export default __webpack_public_path__ + "static/media/checkbox.eb9033b3.svg";